import type { AchievementItem } from "@/types/achievements";
import { ResourceType } from "../resources";
import { AchievementTargetTypes } from "./achievement_target_types";

export const achievements = new Map<number, AchievementItem>([
	[
		1,
		{
			title: "achievement.explored_tiles_1.non_translatable",
			description: "task.explore_tiles",
			target_value: 1_000,
			target_type: AchievementTargetTypes.EXPLORE_TILES,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		2,
		{
			title: "achievement.explored_tiles_2.non_translatable",
			description: "task.explore_tiles",
			target_value: 10_000,
			target_type: AchievementTargetTypes.EXPLORE_TILES,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		3,
		{
			title: "achievement.explored_tiles_3.non_translatable",
			description: "task.explore_tiles",
			target_value: 50_000,
			target_type: AchievementTargetTypes.EXPLORE_TILES,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		4,
		{
			title: "achievement.explored_tiles_4.non_translatable",
			description: "task.explore_tiles",
			target_value: 90_000,
			target_type: AchievementTargetTypes.EXPLORE_TILES,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		5,
		{
			title: "achievement.towns_controlled_1.non_translatable",
			description: "task.control_towns",
			target_value: 10,
			target_type: AchievementTargetTypes.SETTLEMENT_CONTROL,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		6,
		{
			title: "achievement.towns_controlled_2.non_translatable",
			description: "task.control_towns",
			target_value: 25,
			target_type: AchievementTargetTypes.SETTLEMENT_CONTROL,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		7,
		{
			title: "achievement.towns_controlled_3.non_translatable",
			description: "task.control_towns",
			target_value: 50,
			target_type: AchievementTargetTypes.SETTLEMENT_CONTROL,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		8,
		{
			title: "achievement.towns_controlled_4.non_translatable",
			description: "task.control_towns",
			target_value: 100,
			target_type: AchievementTargetTypes.SETTLEMENT_CONTROL,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		9,
		{
			title: "achievement.lumber_income_1.non_translatable",
			description: "task.have_lumber_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_LUMBER_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		10,
		{
			title: "achievement.lumber_income_2.non_translatable",
			description: "task.have_lumber_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_LUMBER_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		11,
		{
			title: "achievement.lumber_income_3.non_translatable",
			description: "task.have_lumber_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_LUMBER_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		12,
		{
			title: "achievement.lumber_income_4.non_translatable",
			description: "task.have_lumber_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_LUMBER_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		13,
		{
			title: "achievement.stone_income_1.non_translatable",
			description: "task.have_stone_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_STONE_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		14,
		{
			title: "achievement.stone_income_2.non_translatable",
			description: "task.have_stone_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_STONE_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		15,
		{
			title: "achievement.stone_income_3.non_translatable",
			description: "task.have_stone_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_STONE_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		16,
		{
			title: "achievement.stone_income_4.non_translatable",
			description: "task.have_stone_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_STONE_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		17,
		{
			title: "achievement.clay_income_1.non_translatable",
			description: "task.have_clay_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_CLAY_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		18,
		{
			title: "achievement.clay_income_2.non_translatable",
			description: "task.have_clay_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_CLAY_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		19,
		{
			title: "achievement.clay_income_3.non_translatable",
			description: "task.have_clay_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_CLAY_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		20,
		{
			title: "achievement.clay_income_4.non_translatable",
			description: "task.have_clay_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_CLAY_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		21,
		{
			title: "achievement.iron_income_1.non_translatable",
			description: "task.have_iron_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_IRON_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		22,
		{
			title: "achievement.iron_income_2.non_translatable",
			description: "task.have_iron_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_IRON_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		23,
		{
			title: "achievement.iron_income_3.non_translatable",
			description: "task.have_iron_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_IRON_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		24,
		{
			title: "achievement.iron_income_4.non_translatable",
			description: "task.have_iron_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_IRON_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		25,
		{
			title: "achievement.goods_income_1.non_translatable",
			description: "task.have_goods_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_GOODS_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		26,
		{
			title: "achievement.goods_income_2.non_translatable",
			description: "task.have_goods_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_GOODS_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		27,
		{
			title: "achievement.goods_income_3.non_translatable",
			description: "task.have_goods_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_GOODS_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		28,
		{
			title: "achievement.goods_income_4.non_translatable",
			description: "task.have_goods_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_GOODS_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		29,
		{
			title: "achievement.steel_income_1.non_translatable",
			description: "task.have_steel_income",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_STEEL_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		30,
		{
			title: "achievement.steel_income_2.non_translatable",
			description: "task.have_steel_income",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_STEEL_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		31,
		{
			title: "achievement.steel_income_3.non_translatable",
			description: "task.have_steel_income",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_STEEL_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		32,
		{
			title: "achievement.steel_income_4.non_translatable",
			description: "task.have_steel_income",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_STEEL_INCOME,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		33,
		{
			title: "achievement.workforce_1.non_translatable",
			description: "task.have_total_workforce",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_WORKFORCE,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		34,
		{
			title: "achievement.workforce_2.non_translatable",
			description: "task.have_total_workforce",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_WORKFORCE,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		35,
		{
			title: "achievement.workforce_3.non_translatable",
			description: "task.have_total_workforce",
			target_value: 25_000,
			target_type: AchievementTargetTypes.HAS_WORKFORCE,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		36,
		{
			title: "achievement.workforce_4.non_translatable",
			description: "task.have_total_workforce",
			target_value: 100_000,
			target_type: AchievementTargetTypes.HAS_WORKFORCE,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		37,
		{
			title: "achievement.super_clickers_used_1.non_translatable",
			description: "task.use_super_clickers",
			target_value: 100,
			target_type: AchievementTargetTypes.HAS_CLICKERS,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		38,
		{
			title: "achievement.super_clickers_used_2.non_translatable",
			description: "task.use_super_clickers",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_CLICKERS,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		39,
		{
			title: "achievement.super_clickers_used_3.non_translatable",
			description: "task.use_super_clickers",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_CLICKERS,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		40,
		{
			title: "achievement.super_clickers_used_4.non_translatable",
			description: "task.use_super_clickers",
			target_value: 100_000,
			target_type: AchievementTargetTypes.HAS_CLICKERS,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		41,
		{
			title: "achievement.roads_built_1.non_translatable",
			description: "task.build_roads",
			target_value: 250,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		42,
		{
			title: "achievement.roads_built_2.non_translatable",
			description: "task.build_roads",
			target_value: 500,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		43,
		{
			title: "achievement.roads_built_3.non_translatable",
			description: "task.build_roads",
			target_value: 1_000,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		44,
		{
			title: "achievement.roads_built_4.non_translatable",
			description: "task.build_roads",
			target_value: 2_500,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		45,
		{
			title: "achievement.roads_built_5.non_translatable",
			description: "task.build_roads",
			target_value: 5_000,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		46,
		{
			title: "achievement.roads_built_6.non_translatable",
			description: "task.build_roads",
			target_value: 10_000,
			target_type: AchievementTargetTypes.HAS_ROADS_BUILD,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		47,
		{
			title: "achievement.ads_watched_1.non_translatable",
			description: "task.watch_ads",
			target_value: 1,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		48,
		{
			title: "achievement.ads_watched_2.non_translatable",
			description: "task.watch_ads",
			target_value: 10,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		49,
		{
			title: "achievement.ads_watched_3.non_translatable",
			description: "task.watch_ads",
			target_value: 50,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		50,
		{
			title: "achievement.ads_watched_4.non_translatable",
			description: "task.watch_ads",
			target_value: 100,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		51,
		{
			title: "achievement.ads_watched_5.non_translatable",
			description: "task.watch_ads",
			target_value: 250,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		52,
		{
			title: "achievement.ads_watched_6.non_translatable",
			description: "task.watch_ads",
			target_value: 500,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		53,
		{
			title: "achievement.ads_watched_7.non_translatable",
			description: "task.watch_ads",
			target_value: 1_000,
			target_type: AchievementTargetTypes.AD_WATCH,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		54,
		{
			title: "achievement.army_strength_1.non_translatable",
			description: "task.have_army_income",
			target_value: 25,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 10,
			},
		},
	],
	[
		55,
		{
			title: "achievement.army_strength_2.non_translatable",
			description: "task.have_army_income",
			target_value: 50,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 15,
			},
		},
	],
	[
		56,
		{
			title: "achievement.army_strength_3.non_translatable",
			description: "task.have_army_income",
			target_value: 100,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 20,
			},
		},
	],
	[
		57,
		{
			title: "achievement.army_strength_4.non_translatable",
			description: "task.have_army_income",
			target_value: 200,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		58,
		{
			title: "achievement.army_strength_5.non_translatable",
			description: "task.have_army_income",
			target_value: 350,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
	[
		59,
		{
			title: "achievement.army_strength_6.non_translatable",
			description: "task.have_army_income",
			target_value: 500,
			target_type: AchievementTargetTypes.HAS_ARMY,
			reward: {
				reward_resource: ResourceType.GEMS,
				amount: 25,
			},
		},
	],
]);
